import { render } from "./OffersListingPage.vue?vue&type=template&id=05341962"
import script from "./OffersListingPage.vue?vue&type=script&lang=js"
export * from "./OffersListingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__